import { render, staticRenderFns } from "./MenuTicket.vue?vue&type=template&id=456f9f4e&scoped=true&"
import script from "./MenuTicket.vue?vue&type=script&lang=js&"
export * from "./MenuTicket.vue?vue&type=script&lang=js&"
import style0 from "./MenuTicket.vue?vue&type=style&index=0&id=456f9f4e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456f9f4e",
  null
  
)

export default component.exports